export const standardJsonParser = <T>(res: Response): Promise<T> => {
  return standardErrorResponseCheck(res)
    .then((res) => res.json())
    .catch((error) => {
      throw new Error(`standardJsonParser failed: ${error.message}`);
    });
};

export const standardErrorResponseCheck = async (res: Response): Promise<Response> => {
  if (res.ok) {
    return res;
  }

  let errorMessage = `HTTP Status: ${res.status}; HTTP Status Text: ${res.statusText}`;

  try {
    errorMessage += `; Response data: ${await res.clone().text()}`;
  } catch {}

  throw new Error(errorMessage);
};

export const alwaysJsonParser = async <T>(res: Response): Promise<T> => {
  try {
    return await standardJsonParser<T>(res);
  } catch {
    return {} as T;
  }
};

export const alwaysArrayParser = async <T>(res: Response): Promise<T[]> => {
  try {
    return await standardJsonParser<T[]>(res);
  } catch {
    return [] as T[];
  }
};
